// Language + dialect configuration for the app.
export const LANGUAGES = [
  { code: "ar", name: "Arabic", native: "العربية", rtl: true },
  { code: "en", name: "English", native: "English" },
  { code: "es", name: "Spanish", native: "Español" },
  { code: "fr", name: "French", native: "Français" },
  { code: "de", name: "German", native: "Deutsch" },
  { code: "it", name: "Italian", native: "Italiano" },
  { code: "pt", name: "Portuguese", native: "Português" },
  { code: "ru", name: "Russian", native: "Русский" },
  { code: "tr", name: "Turkish", native: "Türkçe" },
  { code: "zh", name: "Chinese", native: "中文" },
  { code: "ja", name: "Japanese", native: "日本語" },
  { code: "ko", name: "Korean", native: "한국어" },
  { code: "hi", name: "Hindi", native: "हिन्दी" },
  { code: "ur", name: "Urdu", native: "اردو", rtl: true },
  { code: "fa", name: "Persian", native: "فارسی", rtl: true },
  { code: "he", name: "Hebrew", native: "עברית", rtl: true },
  { code: "nl", name: "Dutch", native: "Nederlands" },
  { code: "pl", name: "Polish", native: "Polski" },
  { code: "id", name: "Indonesian", native: "Bahasa Indonesia" },
  { code: "vi", name: "Vietnamese", native: "Tiếng Việt" },
  { code: "th", name: "Thai", native: "ไทย" },
  { code: "uk", name: "Ukrainian", native: "Українська" },
  { code: "sv", name: "Swedish", native: "Svenska" },
  { code: "no", name: "Norwegian", native: "Norsk" },
  { code: "da", name: "Danish", native: "Dansk" },
  { code: "fi", name: "Finnish", native: "Suomi" },
  { code: "el", name: "Greek", native: "Ελληνικά" },
];

// Dialects by language code. First entry is considered the "standard".
export const DIALECTS = {
  ar: [
    "Modern Standard Arabic (MSA / الفصحى)",
    "Egyptian (مصري)",
    "Levantine (شامي)",
    "Lebanese (لبناني)",
    "Syrian (سوري)",
    "Jordanian (أردني)",
    "Palestinian (فلسطيني)",
    "Gulf / Khaleeji (خليجي)",
    "Saudi / Najdi (سعودي / نجدي)",
    "Saudi Hijazi (حجازي)",
    "Kuwaiti (كويتي)",
    "Emirati (إماراتي)",
    "Qatari (قطري)",
    "Bahraini (بحريني)",
    "Omani (عماني)",
    "Iraqi (عراقي)",
    "Maghrebi (مغاربي)",
    "Moroccan (دارجة)",
    "Tunisian (تونسي)",
    "Algerian (جزائري)",
    "Libyan (ليبي)",
    "Sudanese (سوداني)",
    "Yemeni (يمني)",
  ],
  en: [
    "General / Neutral",
    "American English (US)",
    "British English (UK)",
    "Australian English",
    "Canadian English",
    "Indian English",
    "Irish English",
    "Scottish English",
  ],
  es: [
    "Castilian (Spain)",
    "Latin American (Neutral)",
    "Mexican",
    "Argentinian (Rioplatense)",
    "Chilean",
    "Colombian",
    "Caribbean",
  ],
  pt: ["European Portuguese (pt-PT)", "Brazilian Portuguese (pt-BR)"],
  fr: ["Metropolitan French (France)", "Canadian French (Québécois)", "Belgian French", "African French"],
  zh: ["Mandarin (Simplified)", "Mandarin (Traditional)", "Cantonese"],
  de: ["Standard German (Hochdeutsch)", "Austrian German", "Swiss German"],
  it: ["Standard Italian", "Neapolitan", "Sicilian"],
  hi: ["Standard Hindi", "Colloquial Hindi", "Hinglish"],
  fa: ["Iranian Persian (Farsi)", "Afghan Persian (Dari)", "Tajik"],
};

export function isRTL(code) {
  const l = LANGUAGES.find((x) => x.code === code);
  return !!(l && l.rtl);
}

export function langLabel(code) {
  const l = LANGUAGES.find((x) => x.code === code);
  return l ? `${l.name} — ${l.native}` : code;
}
